import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { QuoteNoteDialogComponent } from '@app/quoting/components/quote-note-dialog/quote-note-dialog.component';
import { WizardService } from '../services/wizard.service';

@Component({
  selector: 'app-wizard-bar-nav',
  templateUrl: './wizard-bar-nav.component.html',
  styleUrls: ['./wizard-bar-nav.component.scss'],
})
export class WizardBarNavComponent implements OnInit, OnDestroy {
  @Input() frmDisabled: boolean;
  @Input() stepIsDirty = false;
  quoteRequestId: any;
  routeSubscription$: any;

  public get steps() {
    return this.wizardService?.activeSteps;
  }

  constructor(public wizardService: WizardService, public dialog: MatDialog, private route: ActivatedRoute) {}

  ngOnDestroy(): void {
    this.routeSubscription$.unsubscribe();
  }

  public stepClicked(step: any) {
    this.wizardService.stepClicked(step, this.stepIsDirty);
  }

  ngOnInit(): void {
    this.routeSubscription$ = this.route.params.subscribe((x) => {
      this.quoteRequestId = null;
      if (!isNaN(x.quoteRequestId)) {
        this.quoteRequestId = Number(x.quoteRequestId);
      }
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(QuoteNoteDialogComponent, {
      height: '400px',
      width: '755px',
      data: this.quoteRequestId,
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }
}
